import React from "react";

// Shared by the Library tab and its list.
export const CHANNEL_NAME = { push: "Push", email: "Email", whatsapp: "WhatsApp", sms: "SMS" };

const WA_STATE = {
    DRAFT: { text: "Draft: not sent to Meta", cls: "bg-secondary-subtle text-secondary" },
    PENDING: { text: "Waiting for Meta", cls: "bg-warning-subtle text-warning-emphasis" },
    IN_APPEAL: { text: "Appeal at Meta", cls: "bg-warning-subtle text-warning-emphasis" },
    APPROVED: { text: "Approved", cls: "bg-success-subtle text-success" },
    FLAGGED: { text: "Approved, flagged", cls: "bg-warning-subtle text-warning-emphasis" },
    REJECTED: { text: "Rejected", cls: "bg-danger-subtle text-danger" },
    PAUSED: { text: "Paused by Meta", cls: "bg-danger-subtle text-danger" },
    DISABLED: { text: "Disabled by Meta", cls: "bg-danger-subtle text-danger" },
};
export const waState = (status) => WA_STATE[String(status || "DRAFT").toUpperCase()] || { text: String(status).toLowerCase(), cls: "bg-secondary-subtle text-secondary" };

// The WhatsApp template's standing at Meta, with Meta's reason and a note when edits wait to be sent.
export const WaStatus = ({ wa = {}, compact = false }) => {
    const state = waState(wa.status);
    return (
        <div className={compact ? "" : "text-end"}>
            <span className={`nc-status ${state.cls}`} style={{ textTransform: "none" }}>{state.text}</span>
            {!compact && wa.reason ? <div className="nc-sub mt-1">Meta: {wa.reason}</div> : null}
            {!compact && wa.changedSinceSubmit ? <div className="nc-sub mt-1">Saved changes are not at Meta yet; customers get the approved wording.</div> : null}
        </div>
    );
};
